import * as constants from '../constants';

const INITIAL_STATE = {
    current: null,
    error: null,
    submitting: false,
};

export default function instanceReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.INSTANCE_REQUESTED:
            return Object.assign({}, state, {current: null});
        case constants.INSTANCE_FAILURE:
            return Object.assign({}, state, {current: null, error: action.payload.error});
        case constants.INSTANCE_POST_REQUESTED:
            return Object.assign({}, state, {submitting: true});
        case constants.INSTANCE_POST_FAILURE:
            return Object.assign({}, state, {submitting: false, error: action.payload.error});
        case constants.INSTANCE_SUCCESS:
        case constants.INSTANCE_POST_SUCCESS:
            return Object.assign({}, state, {current: action.payload.instance, error: null, submitting: false});
    }
    return state;
}
